import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { ArrowDownCircleFill } from 'react-bootstrap-icons';
import { DeferredPromptContext } from '../../../contexts/DeferredPromptContext';

function InstallShortcutButton() {
    const { deferredPrompt, setDeferredPrompt } = useContext(DeferredPromptContext);

    const handleInstallClick = async () => {
        if (deferredPrompt && typeof deferredPrompt.prompt === 'function') {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            console.log(`El usuario seleccionó: ${outcome}`);
            setDeferredPrompt(null);
        }
    };

    return (
        <Button
            variant="danger"
            className="d-flex align-items-center position-relative"
            onClick={handleInstallClick}
            disabled={!deferredPrompt || typeof deferredPrompt.prompt !== 'function'}
            aria-label="Instalar aplicación"
            title="Instalar la aplicación en tu dispositivo"
        >
            <ArrowDownCircleFill size={20} className='me-2' />
            <span className='ms-0 ms-md-2'>Crear Atajo</span>
        </Button>
    );
}

export default InstallShortcutButton;
